<template>
  <main>
    <app-header :user="user" />
    <me-navigation-error
      title="Não encontramos a página"
      description="Por favor, tente novamente ou volte para o início."
      :image="{
        url: '/images/ilustrations/404.svg',
        alt: 'Ilustração de uma porta aberta levando para um quarto escuro com uma caixa vazia abandonada',
      }"
    />
  </main>
</template>

<script>
import NavigationError from 'commons/js/layouts/NavigationError.vue';
import Header from './Header'

export default {
  props: ['user'],

  components: {
    'app-header': Header,
    'me-navigation-error': NavigationError,
  },
}
</script>
